/**
 * Lightweight hotkey registry. Keys are case-insensitive; modifiers are
 * ignored for Phase 0 (no shortcuts collide with browser defaults yet).
 */

export type KeyHandler = () => void;

export class KeyboardRouter {
  private handlers = new Map<string, KeyHandler>();
  private boundHandler = (e: KeyboardEvent) => this.dispatch(e);

  on(key: string, handler: KeyHandler): void {
    this.handlers.set(key.toLowerCase(), handler);
  }

  attach(target: Window | HTMLElement = window): () => void {
    target.addEventListener('keydown', this.boundHandler as EventListener);
    return () => target.removeEventListener('keydown', this.boundHandler as EventListener);
  }

  private dispatch(e: KeyboardEvent): void {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    const tag = (e.target as HTMLElement | null)?.tagName?.toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
    const fn = this.handlers.get(e.key.toLowerCase());
    if (fn) {
      e.preventDefault();
      fn();
    }
  }
}
